module.exports = __webpack_public_path__ + "img/final-step.c3ac831a.png";